import { makeActionCreator } from '../../../../utilities'
import { CriticalCareConstants } from './criticalCare.constants'

export const setAction = makeActionCreator(CriticalCareConstants.SET_ACTION, 'action')
export const setSite = makeActionCreator(CriticalCareConstants.SET_SITE, 'site')
export const setTask = makeActionCreator(CriticalCareConstants.SET_TASK, 'task')
export const setTransducerZeroedPre = makeActionCreator(
  CriticalCareConstants.SET_TRANSDUCER_ZEROED_PRE,
  'transducerZeroedPre'
)
export const setTransducerZeroedPost = makeActionCreator(
  CriticalCareConstants.SET_TRANSDUCER_ZEROED_POST,
  'transducerZeroedPost'
)
export const setTriggerUtilizedPre = makeActionCreator(
  CriticalCareConstants.SET_TRIGGER_UTILIZED_PRE,
  'triggerUtilizedPre'
)
export const setTriggerUtilizedPost = makeActionCreator(
  CriticalCareConstants.SET_TRIGGER_UTILIZED_POST,
  'triggerUtilizedPost'
)
export const setIabpFrequencyPre = makeActionCreator(CriticalCareConstants.SET_IABP_FREQUENCY_PRE, 'IABPFrequencyPre')
export const setIabpFrequencyPost = makeActionCreator(
  CriticalCareConstants.SET_IABP_FREQUENCY_POST,
  'IABPFrequencyPost'
)
export const setIabpAugmentationPre = makeActionCreator(
  CriticalCareConstants.SET_IABP_AUGMENTATION_PRE,
  'IABPAugmentationPre'
)
export const setIabpAugmentationPost = makeActionCreator(
  CriticalCareConstants.SET_IABP_AUGMENTATION_POST,
  'IABPAugmentationPost'
)
export const setSlowGasLeakAlarmPre = makeActionCreator(
  CriticalCareConstants.SET_SLOW_GAS_LEAK_ALARM_PRE,
  'slowGasLeakAlarmPre'
)
export const setSlowGasLeakAlarmPost = makeActionCreator(
  CriticalCareConstants.SET_SLOW_GAS_LEAK_ALARM_POST,
  'slowGasLeakAlarmPost'
)
export const setTimingPre = makeActionCreator(CriticalCareConstants.SET_TIMING_PRE, 'timingPre')
export const setTimingPost = makeActionCreator(CriticalCareConstants.SET_TIMING_POST, 'timingPost')
export const setIabpFillPre = makeActionCreator(CriticalCareConstants.SET_IABP_FILL_PRE, 'IABPFillPre')
export const setIabpFillPost = makeActionCreator(CriticalCareConstants.SET_IABP_FILL_POST, 'IABPFillPost')
export const setAugmentationAlarmSetPre = makeActionCreator(
  CriticalCareConstants.SET_AUGMENTATION_ALARM_SET_PRE,
  'augmentationAlarmSetPre'
)
export const setAugmentationAlarmSetPost = makeActionCreator(
  CriticalCareConstants.SET_AUGMENTATION_ALARM_SET_POST,
  'augmentationAlarmSetPost'
)
export const setLeftBrachialPulsePre = makeActionCreator(
  CriticalCareConstants.SET_LEFT_BRACHIAL_PULSE_PRE,
  'leftBrachialPulsePre'
)
export const setLeftBrachialPulsePost = makeActionCreator(
  CriticalCareConstants.SET_LEFT_BRACHIAL_PULSE_POST,
  'leftBrachialPulsePost'
)
export const setDistalPulsePresentInAffectedExtremityPre = makeActionCreator(
  CriticalCareConstants.SET_DISTAL_PULSE_PRESENT_IN_AFFECTED_EXTREMITY_PRE,
  'distalPulsePre'
)
export const setDistalPulsePresentInAffectedExtremityPost = makeActionCreator(
  CriticalCareConstants.SET_DISTAL_PULSE_PRESENT_IN_AFFECTED_EXTREMITY_POST,
  'distalPulsePost'
)
export const setInsertionSitePre = makeActionCreator(
  CriticalCareConstants.SET_INSERTION_SITE_PRE,
  'insertionSitePulsePre'
)
export const setInsertionSitePost = makeActionCreator(
  CriticalCareConstants.SET_INSERTION_SITE_POST,
  'insertionSitePulsePost'
)
export const setExtremityRestrainedPre = makeActionCreator(
  CriticalCareConstants.SET_EXTREMITY_RESTRAINED_PRE,
  'extremityRestrainedPre'
)
export const setExtremityRestrainedPost = makeActionCreator(
  CriticalCareConstants.SET_EXTREMITY_RESTRAINED_POST,
  'extremityRestrainedPost'
)
export const setInflationPointPre = makeActionCreator(
  CriticalCareConstants.SET_INFLATION_POINT_PRE,
  'inflationPointPre'
)
export const setInflationPointPost = makeActionCreator(
  CriticalCareConstants.SET_INFLATION_POINT_POST,
  'inflationPointPost'
)

export const setDeflationPointPre = makeActionCreator(
  CriticalCareConstants.SET_DEFLATION_POINT_PRE,
  'deflationPointPre'
)
export const setDeflationPointPost = makeActionCreator(
  CriticalCareConstants.SET_DEFLATION_POINT_POST,
  'deflationPointPost'
)

export const setDiastolicAugmentationPre = makeActionCreator(
  CriticalCareConstants.SET_DIASTOLIC_AUGMENTATION_PRE,
  'diastolicAugmentationPre'
)
export const setDiastolicAugmentationPost = makeActionCreator(
  CriticalCareConstants.SET_DIASTOLIC_AUGMENTATION_POST,
  'diastolicAugmentationPost'
)

export const setUnaugmentedDiastolePre = makeActionCreator(
  CriticalCareConstants.SET_UNAUGMENTED_DIASTOLE_PRE,
  'unaugmentedDiastolePre'
)
export const setUnaugmentedDiastolePost = makeActionCreator(
  CriticalCareConstants.SET_UNAUGMENTED_DIASTOLE_POST,
  'unaugmentedDiastolePost'
)

export const setDiastolicDipPre = makeActionCreator(CriticalCareConstants.SET_DIASTOLIC_DIP_PRE, 'diastolicDipPre')
export const setDiastolicDipPost = makeActionCreator(CriticalCareConstants.SET_DIASTOLIC_DIP_POST, 'diastolicDipPost')

export const setAugmentedSystolePre = makeActionCreator(
  CriticalCareConstants.SET_AUGMENTED_SYSTOLE_PRE,
  'augmentedSystolePre'
)
export const setAugmentedSystolePost = makeActionCreator(
  CriticalCareConstants.SET_AUGMENTED_SYSTOLE_POST,
  'augmentedSystolePost'
)

export const setUnaugmentedSystolePre = makeActionCreator(
  CriticalCareConstants.SET_UNAUGMENTED_SYSTOLE_PRE,
  'unaugmentedSystolePre'
)
export const setUnaugmentedSystolePost = makeActionCreator(
  CriticalCareConstants.SET_UNAUGMENTED_SYSTOLE_POST,
  'unaugmentedSystolePost'
)
export const onSelectCriticalCareProcedure = makeActionCreator(CriticalCareConstants.ON_SELECT_CRITICAL_CARE)
export const setAddToTimeLine = makeActionCreator(CriticalCareConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setDateTime = makeActionCreator(CriticalCareConstants.SET_DATE_TIME, 'time', 'date')
export const saveCriticalCare = makeActionCreator(CriticalCareConstants.SAVE_CRITICAL_CARE, 'data')
export const setSize = makeActionCreator(CriticalCareConstants.SET_SIZE, 'size')
export const setAssessedBy = makeActionCreator(CriticalCareConstants.SET_ASSESSED_BY, 'assessedBy')
export const setSuccessfulAttempt = makeActionCreator(CriticalCareConstants.SET_SUCCESSFUL_ATTEMPT, 'successfulAttempt')
export const setAttempts = makeActionCreator(CriticalCareConstants.SET_ATTEMPTS, 'attempts')
export const resetState = makeActionCreator(CriticalCareConstants.RESET_STATE)
export const resetIABPFields = makeActionCreator(CriticalCareConstants.RESET_IABP_FIELDS)
export const setRolePerforming = makeActionCreator(CriticalCareConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const setState = makeActionCreator(CriticalCareConstants.SET_STATE, 'criticalCareState')
export const setDefaultValuesForIABP = makeActionCreator(CriticalCareConstants.SET_DEFAULT_VALUES_FOR_IABP)
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  CriticalCareConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  CriticalCareConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
